// API client for v7p3r-labs backend

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';

export interface CreateGameRequest {
  white: {
    type: 'human' | 'engine';
    engine_version?: '18.4';
  };
  black: {
    type: 'human' | 'engine';
    engine_version?: '18.4';
  };
  time_control: {
    minutes: number;
    increment: number;
  };
}

export interface CreateGameResponse {
  game_id: string;
}

export const api = {
  async createGame(config: CreateGameRequest): Promise<CreateGameResponse> {
    const response = await fetch(`${API_BASE_URL}/games`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(config),
    });

    if (!response.ok) {
      throw new Error(`Failed to create game: ${response.statusText}`);
    }

    return response.json();
  },

  getWebSocketUrl(gameId: string): string {
    const wsUrl = API_BASE_URL.replace('http://', 'ws://').replace('https://', 'wss://');
    return `${wsUrl}/ws/game/${gameId}`;
  },
};
